import styled from 'styled-components';
import { Table } from '@exxonmobil/react-unity';

export const TableHeadRow = styled(Table.Head.Row)`
  display: table;
  width: 100%;
  table-layout: fixed;
`;
export const TableBodyRow = styled(Table.Body.Row)`
  display: table;
  width: 100%;
  table-layout: fixed;
`;
export const TableCell = styled(Table.Body.Cell)`
  display: 'table-cell';
  vertical-align: middle;
`;
export const StyledTable = styled(Table)`
  border: '1px solid #e5e5e5';
`;
